import GameInfo from '@/components/features/casino/game-info';
import { useTranslation } from 'next-i18next';

import step1Img from '/public/assets/images/casino/crash/crash-work-step-1.png'
import step2Img from '/public/assets/images/casino/crash/crash-work-step-2.png'
import step3Img from '/public/assets/images/casino/crash/crash-work-step-3.png'
import step4Img from '/public/assets/images/casino/crash/crash-work-step-4.png'
import HowItWorks from '@/components/ui/HowItWorks';


export default function CrashGameInfo() {
  const { t } = useTranslation();

  
  const howItWorksSteps = [
    {
      text: t(`Specify your bet value.`),
      imageSrc: step1Img.src
    },
    {
      text: t(`Optionally, turn on and set an auto cashout value. If this multiplier is hit, the
bet will be cashed out.`),
      imageSrc: step2Img.src
    },
    {
      text: t(`The game can crash at
anytime. If the game crashes
before you cashout, your initial
bet will be lost.`),
      imageSrc: step3Img.src
    },
    {
      text: t(`If you cashout before the
game crashes, your bet is
multiplied by the multiplier you cashed out at.`),
      imageSrc: step4Img.src
    },
  ]
   
   return (
    <GameInfo title={t('Crash')} gameId={'1004'}>
       <HowItWorks steps={howItWorksSteps} ></HowItWorks>
    </GameInfo>
  );
}
